import VerticalEnterpriseHeadshotDots from "./VerticalEnterpriseHeadshotDots";
import HeroSlider from "./HeroSlider";
import AnimatedDotsConnections from "./AnimatedDotsConnections";
class VerticalEnterprise {
    constructor() {
        const enterpriseHero = document.getElementById('ent-hero-canvas');
        const enterpriseAnimationBar = document.getElementById('canvas-ent-animation');
        const enterpriseAnimationFooter = document.getElementById('ent-subscription-canvas-wrapper');
        const enterpriseAnimationAsideEl = document.getElementById('ent-aside-canvas');
        let verticalEnterpriseHero, verticalEnterpriseAnimationBar, verticalEnterpriseAnimationFooter, verticalEnterpriseAnimationAside;

        if(enterpriseHero) {
            const heroConnectionsForegroundOptions = {
                minDots: 30,
                maxDots: 130,
                minDistance: 0.0025,
                maxDistance: 0.15,
                yOffsetMin: -0.3,
                yOffsetMax: 0.1,
            }

            const heroConnectionsBackgroundOptions = {
                minDots: 20,
                maxDots: 100,
                minDistance: 0.025,
                maxDistance: 0.1,
                yOffsetMin: -0.4,
                yOffsetMax: 0.15,
                baseline: 'wave',
                blur: true,
                alpha: 0.3
            }

            verticalEnterpriseHero = new AnimatedDotsConnections(enterpriseHero, heroConnectionsForegroundOptions, heroConnectionsBackgroundOptions);
        }

        if(enterpriseAnimationBar) {
            const enterpriseAnimationBarForegroundOptions = {
                minDots: 20,
                maxDots: 100,
                minDistance: 0.001,
                maxDistance: 0.25,
                yOffsetMin: -0.5,
                yOffsetMax: 0.4,
                baseline: 'line',
                color: '#ffffff',
            }

            verticalEnterpriseAnimationBar = new AnimatedDotsConnections(enterpriseAnimationBar, enterpriseAnimationBarForegroundOptions);
        }

        if(enterpriseAnimationFooter) {
            const footerConnectionsForegroundOptions = {
                minDots: 30,
                maxDots: 120,
                minDistance: 0.001,
                maxDistance: 0.25,
                yOffsetMin: -0.5,
                yOffsetMax: 0.4,
                baseline: 'line',
                color: '#ffffff',
                topOffset: 0.3,
                limitTop: true
            }

            const footerConnectionsBackgroundOptions = {
                minDots: 20,
                maxDots: 100,
                minDistance: 0.001,
                maxDistance: 0.25,
                yOffsetMin: -0.5,
                yOffsetMax: 0.4,
                baseline: 'line',
                color: '#ffffff',
                topOffset: 0.3,
                limitTop: true,
                blur: true,
                alpha: 0.3
            }

            verticalEnterpriseAnimationFooter = new AnimatedDotsConnections(enterpriseAnimationFooter, footerConnectionsForegroundOptions, footerConnectionsBackgroundOptions);
        }

        if(enterpriseAnimationAsideEl) {
            const enterpriseAnimationAsideForegroundOptions = {
                minDots: 26,
                maxDots: 26,
                minDistance: 0.001,
                maxDistance: 0.25,
                yOffsetMin: 0.1,
                yOffsetMax: 0.4,
                baseline: 'line',
                color: '#46FFBC',
                // topOffset: 0.1,
                limitTop: true
            }

            verticalEnterpriseAnimationAside = new AnimatedDotsConnections(enterpriseAnimationAsideEl, enterpriseAnimationAsideForegroundOptions);
        }

        if(enterpriseHero || enterpriseAnimationBar || enterpriseAnimationFooter || enterpriseAnimationAsideEl) {
            const observerCallback = (entries, observer) => {
                entries.forEach(entry => {
                    if (enterpriseHero && entry.target === enterpriseHero) {
                        if (entry.isIntersecting) {
                            verticalEnterpriseHero.startAnimation();
                        } else {
                            verticalEnterpriseHero.stopAnimation();
                        }
                    }

                    if (enterpriseAnimationBar && entry.target === enterpriseAnimationBar) {
                        if (entry.isIntersecting) {
                            verticalEnterpriseAnimationBar.startAnimation();
                        } else {
                            verticalEnterpriseAnimationBar.stopAnimation();
                        }
                    }

                    if (enterpriseAnimationFooter && entry.target === enterpriseAnimationFooter) {
                        if (entry.isIntersecting) {
                            verticalEnterpriseAnimationFooter.startAnimation();
                        } else {
                            verticalEnterpriseAnimationFooter.stopAnimation();
                        }
                    }

                    if (enterpriseAnimationAsideEl && entry.target === enterpriseAnimationAsideEl) {
                        if (entry.isIntersecting) {
                            verticalEnterpriseAnimationAside.startAnimation();
                        } else {
                            verticalEnterpriseAnimationAside.stopAnimation();
                        }
                    }
                });
            };

            const observerOptions = {
                root: null,
                rootMargin: '0px',
                threshold: 0
            };

            const observer = new IntersectionObserver(observerCallback, observerOptions);
            if(enterpriseHero) {
                observer.observe(enterpriseHero);
            }

            if(enterpriseAnimationBar) {
                observer.observe(enterpriseAnimationBar);
            }

            if(enterpriseAnimationFooter) {
                observer.observe(enterpriseAnimationFooter);
            }

            if(enterpriseAnimationAsideEl) {
                observer.observe(enterpriseAnimationAsideEl);
            }
        }

        this.headshotsGP = document.querySelectorAll('.ent-general-partner');
        if(this.headshotsGP.length > 0) {
            this.headshotsGP.forEach((headshot) => {
                new VerticalEnterpriseHeadshotDots(headshot, 10, 26, 0.001, 0.25, 0.1, 0.4, 'line', '#ffffff', 0.1, true);
            });
        }

        this.initSliders();
    }

    initSliders() {
        const swiperEl = document.querySelector('.ent-hero-slider');
        if(swiperEl) {
            new HeroSlider(swiperEl);
        }
    }
}

export default VerticalEnterprise
